/**
 * Digio Web SDK Integration Utility
 * Documentation: https://documentation.digio.in/sdk/web/web/
 */

export interface DigioTheme {
  primaryColor: string;
  secondaryColor: string;
}

export interface DigioCallbackResponse {
  error_code?: string;
  error_message?: string;
  message?: string;
  request_id?: string;
  status?: string;
}

export interface DigioConfig {
  environment: 'sandbox' | 'production';
  is_iframe?: boolean;
  logo?: string;
  theme?: DigioTheme;
  callback?: (response: DigioCallbackResponse) => void;
  event_listener?: (response: DigioCallbackResponse) => void;
}

declare global {
  interface Window {
    Digio: any;
  }
}

export const isDigioSDKLoaded = (): boolean =>
  typeof window !== 'undefined' && typeof window.Digio !== 'undefined';

export const launchDigioSign = (
  documentId: string,
  customerIdentifier: string,
  tokenId: string,
  config?: Partial<DigioConfig>
): void => {
  if (!isDigioSDKLoaded()) {
    throw new Error('Digio SDK not loaded');
  }

  const defaultConfig: DigioConfig = {
    environment:
      (process.env.REACT_APP_DIGIO_ENVIRONMENT as 'sandbox' | 'production') ||
      'sandbox',
    is_iframe: true,
    logo: process.env.REACT_APP_DIGIO_LOGO || '',
    theme: {
      primaryColor: '#008080',
      secondaryColor: '#FFFFFF'
    }
  };

  const finalConfig: DigioConfig = {
    ...defaultConfig,
    ...config,
    theme: {
      ...defaultConfig.theme,
      ...config?.theme
    } as DigioTheme
  };

  const digio = new window.Digio(finalConfig);
  digio.init();
  digio.submit(documentId, customerIdentifier, tokenId);
};
